import React, { createRef , useRef, useState  } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import Costanti from '../../constantiX';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Formik, replace } from 'formik';
import * as Yup from 'yup';
import { Galleria } from "primereact/galleria";
import ReactGA from 'react-ga4';
import {FormattedMessage, useIntl} from 'react-intl';


import { DataTable,Column,Button,Dialog} from "primereact";




  
      

    class SchedaAzienda extends React.Component {

 
      constructor() {
            super();
           this.token=sessionStorage.getItem("ICEtoken");
           this.utente=JSON.parse(sessionStorage.getItem("utente"));
           this.aziendaid=0;
           this.state = { xcarica:'sezione', tipoVisual:0 , width: 0, height: 0,  immagine:'', dati:[], totalRecords:0, pageSize:10, first:0, rows:10, visible1:false, visible2: false,visible3: false, loading:true, editMode:true, isSubmitting:false};
           this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
           this.options = {
            center: {lat: 36.890257, lng: 30.707417},
            zoom: 12
        };
        
    }

      updateWindowDimensions() {

        var tipow=3;
        if(window.innerWidth>=0 && window.innerWidth<767)tipow=1;
        if(window.innerWidth>=768 && window.innerWidth<1024)tipow=2;
        this.setState({ tipoVisual : tipow, width: window.innerWidth, height: window.innerHeight });
      }

      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      
      componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        ReactGA.send({ hitType: "pageview", page:this.props.location.pathname});
     
       var id=this.props.match.params.id;
     
        this.aziendaid=id;
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          
         this.setState({loading:true,id:id});
         var quer=id;
         axios.get(Costanti.UrlCallApi+"scheda/azienda/"+quer,config)
                .then(res => {
                    this.setState({dati:res.data,loading:false,editMode:false});
                   // this.settaImg();
                 }).catch(error=> {
             alert(error)
        });
    
    
  
        this.responsiveOptions = [
            {
                breakpoint: "768px",
                numVisible: 3,
            },
            {
                breakpoint: "560px",
                numVisible: 2,
            },
        ];
      }

      settaImg(){
      
        try{
        var s=this.state.dati.lista3[0];
        var id=s[0].id;
        var testo=Costanti.UrlCallApi+'file/get/'+this.aziendaid+'/stabilimento/'+id+'?'+Math.random();
        this.setState({imgsrc:testo})
      }catch{}
    }

      showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){icona='pi pi-times-circle';}
        if(tipo=='info'){icona='pipi-info-circle';}
        if(tipo=='success'){icona='pi pi-check-circle';}
        if(tipo=='warning'){icona='pi pi-exclamation-triangle';}
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }
 

      setVisible1(val){
        this.setState({visible1:val});
       
      }

      split4(sentence){
        var rit="";
            try {
              rit=sentence.substring(0,50)+(sentence.length>50?"...":"");
        
            } catch (error) {
              rit="";
            }           
            return rit;
      }

      splitfacebook(sentence){
    
        var rit="";
            try {
              let parts = sentence.split("/");
              rit=parts[3];

            } catch (error) {
              rit="";
            }           
            return rit;
      }
     

      lingua(){
        var a="";
        if(document.getElementById("aaGG"))
        a=document.getElementById("aaGG").innerText;
        if(a==="") a=(navigator.language=== 'it-IT'?"IT":"UK");
        return a;
      }
         
        render() {
        return( 
            <div>

<Dialog visible={this.state.visible1} closable={false} modal 
  style={{ width: '90%', height:'100%' }} header="Mappa" draggable={false} resizable={false}
   footer={<div className="border-top-1 surface-border pt-3">
            <Button icon="pi pi-check" onClick={() => this.setVisible1(false)} label="Chiudi" />
            </div>}>
            <div className="flex flex-wrap border-top-1 surface-border pt-4">
            

                <iframe style={{width:'100vw',height:'60vh'}}   id="gmap_canvas" 
                src={'https://maps.google.com/maps?q='+this.mappa+'&t=&z=13&ie=UTF8&iwloc=&output=embed'} 
                frameborder="0" marginheight="0" marginwidth="0"></iframe>
            </div>
        </Dialog>
    
             <div>
             {this.state.tipoVisual==1?
             <div>
              <div class="grid p-3">
                 <div className="col-4">
                 <div className="card  flex align-items-center justify-content-center">
                  {(this.state.dati.lista2?
                 <img src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista2[0].id+'/logo/'+this.state.dati.lista2[0].id}  
                 style={{top:'60%', left:'60%', maxWidth:'100%', maxHeight:'100%', objectFit: 'contain'}}  />:"")}
                 </div>
                 </div>
                 <div class="col-8">
                     <div className="azie1 text-3xl">
                       {(this.state.dati.lista2?this.state.dati.lista2[0].ragionesociale:"")}
                    </div>
                </div>
                <div class="grid p-3">
                        <div className="col-12"> 
                            <div onClick={()=>{this.mappa=(this.state.dati.lista2?this.state.dati.lista2[0].sede:"-");
                            this.setVisible1(true)}} style={{cursor:'pointer'}}>
                              <i className="pi pi-map-marker mr-2"></i>
                            {(this.state.dati.lista2?this.state.dati.lista2[0].sede:"")}
                            </div>
                            </div>
                        

                        <div className="col-12"> 
                          
                          <i className="pi pi-envelope mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].email:"")}
                        </div>
                        <div className="col-12"> 
                            <i className="pi pi-phone mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].telefono:"")}
                        </div>
                      
                 </div>
                 <div class="grid p-3">
                    <div className="col-12 azie2">
                      Social Media
                   </div>
                   <div className="col-12"> 
              
                          <i className="pi pi-desktop mr-2" style={{ color:'#CFC6C3'}}></i> 
                          <a href={(this.state.dati.lista2?this.state.dati.lista2[0].sitoweb:"")}  target="_blank"  style={{cursor:'pointer'}}> {(this.state.dati.lista2?this.state.dati.lista2[0].sitoweb:"")}
                          </a>
                        </div>

                   <div className="col-12"> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].instagram):"")!=""?
                   <>
                   <a href={(this.state.dati.lista2?this.state.dati.lista2[0].instagram:"")} 
                    target="_blank"  style={{cursor:'pointer'}}> 
                   <i className="pi pi-instagram mr-2" style={{ color:'#CFC6C3'}}></i> {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].instagram):"")}
                   </a>
                   </>:<></>}
                   </div>
                   <div className="col-12"> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].facebook):"")!=""?
                    <>
                   
                   <a href={(this.state.dati.lista2?this.state.dati.lista2[0].facebook:"")} 
                    target="_blank"  style={{cursor:'pointer'}}> 
                   <i className="pi pi-facebook mr-2" style={{ color:'#CFC6C3'}}></i> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].facebook):"")}
                  </a>
                   </>:<></>}
                   </div>
                   
                 </div>
              
             </div>
             <div className="grid grid-nogutter">
               <div className="col-12 col-12 md:col-12 lg:col-12 p-3">
               <div className="azie2">
                     <FormattedMessage id = "azienda.sudinoi" />
                   </div>
               </div>
               <div className="col-12 col-12 md:col-12 lg:col-12 p-3">
               <div className="azie3">
                {(this.state.dati.lista2?(
                 this.lingua()=='IT'? this.state.dati.lista2[0].info:this.state.dati.lista2[0].infoen
                     ):"")}
               </div>
               </div>
               </div>
             </div>:""}
             {this.state.tipoVisual==2?
             <div>
              <div class="grid p-3">
                 <div class="col-4">
                 <div className="card  flex align-items-center justify-content-center">
               
               {(this.state.dati.lista2?
                 <img src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista2[0].id+'/logo/'+this.state.dati.lista2[0].id+'?'+Math.random()}  
                 style={{ maxWidth:'100%', maxHeight:'100%', objectFit: 'contain'}}  />:"")}
                 </div>
                 </div>
                 <div class="col-8">
                     <div className="azie1 text-3xl">
                       {(this.state.dati.lista2?this.state.dati.lista2[0].ragionesociale:"")}
                    </div>
                        <div class="grid p-3">
                        <div className="col-12  p-3"> 
                            <div onClick={()=>{this.mappa=(this.state.dati.lista2?this.state.dati.lista2[0].sede:"-");this.setVisible1(true)}} style={{cursor:'pointer'}}>
                              <i className="pi pi-map-marker  mr-2"></i>
                            {(this.state.dati.lista2?this.state.dati.lista2[0].sede:"")}
                            </div>
                            </div>
                        
                            <div className="col-6  p-3"> 
                          
                          <i className="pi pi-envelope  mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].email:"")}
                        </div>
                        <div className="col-6  p-3"> 
                            <i className="pi pi-phone  mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].telefono:"")}
                        </div>
                      
                      </div>
                  </div>
                  </div>
                  
                   <div class="grid p-3">
                    <div className="col-12 azie2">
                      Social Media
                   </div>
                   <div className="col-4"> 
              
                          <i className="pi pi-desktop mr-2" style={{ color:'#CFC6C3'}}></i> 
                          <a href={(this.state.dati.lista2?this.state.dati.lista2[0].sitoweb:"")}  target="_blank"  style={{cursor:'pointer'}}> {(this.state.dati.lista2?this.state.dati.lista2[0].sitoweb:"")}
                          </a>
                    </div>

                    <div className="col-4"> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].instagram):"")!=""?
                   <>
                   <a href={(this.state.dati.lista2?this.state.dati.lista2[0].instagram:"")} 
                    target="_blank"  style={{cursor:'pointer'}}> 
                   <i className="pi pi-instagram mr-2" style={{ color:'#CFC6C3'}}></i> {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].instagram):"")}
                   </a>
                   </>:<></>}
                   </div>
                   <div className="col-4"> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].facebook):"")!=""?
                    <>
                   
                   <a href={(this.state.dati.lista2?this.state.dati.lista2[0].facebook:"")} 
                    target="_blank"  style={{cursor:'pointer'}}> 
                   <i className="pi pi-facebook mr-2" style={{ color:'#CFC6C3'}}></i> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].facebook):"")}
                  </a>
                   </>:<></>}
                   </div>
                   
                   
               

              
             </div>
 
             <div className="grid grid-nogutter">
               <div className="col-12 col-12 md:col-12 lg:col-12 p-3">
               <div className="azie2">
                     <FormattedMessage id = "azienda.sudinoi" />
                   </div>
               </div>
               <div className="col-12 col-12 md:col-12 lg:col-12 p-3">
               <div className="azie3">
                {(this.state.dati.lista2?(
                 this.lingua()=='IT'? this.state.dati.lista2[0].info:this.state.dati.lista2[0].infoen
                     ):"")}
               </div>
               </div>
               </div>
             </div>:""}
             {this.state.tipoVisual==3?
             <div>

              <div class="grid p-3">
                 <div class="col-4">
                 <div className="card  flex align-items-center justify-content-center">
                    
                
                 {(this.state.dati.lista2?
                 <img className="border-round"  src={Costanti.UrlCallApi+'file/get/'+this.state.dati.lista2[0].id+'/logo/'+this.state.dati.lista2[0].id+'?'+Math.random()}  
                 style={{top:'60%', left:'60%', maxWidth:'100%', maxHeight:'100%', objectFit: 'contain'}}  />:"")}
                 </div>
                 </div>
                 <div class="col-8">
                     <div className="azie1 text-3xl">
                       {(this.state.dati.lista2?this.state.dati.lista2[0].ragionesociale:"")}
                    </div>

                    <div class="grid p-3">
                        <div className="col-12"> 
                            <div onClick={()=>{this.mappa=(this.state.dati.lista2?this.state.dati.lista2[0].sede:"-");this.setVisible1(true)}} style={{cursor:'pointer'}}>
                              <i className="pi pi-map-marker  mr-2"></i>
                            {(this.state.dati.lista2?this.state.dati.lista2[0].sede:"")}
                            </div>
                            </div>
                        

                        <div className="col-6"> 
                          
                          <i className="pi pi-envelope  mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].email:"")}
                        </div>
                        <div className="col-6"> 
                            <i className="pi pi-phone  mr-2"></i> {(this.state.dati.lista2?this.state.dati.lista2[0].telefono:"")}
                        </div>
                      
                      </div>

                </div>
             </div>
             

             <div class="grid p-3">
                 <div class="col-4">
             
                 <div class="grid p-3">
                    <div className="col-12 azie2">
                      Social Media
                   </div>
                   <div className="col-12"> 
              
                          <i className="pi pi-desktop mr-2" style={{ color:'#CFC6C3'}}></i> 
                          <a href={(this.state.dati.lista2?this.state.dati.lista2[0].sitoweb:"")}  target="_blank"  style={{cursor:'pointer'}}> {(this.state.dati.lista2?this.state.dati.lista2[0].sitoweb:"")}
                          </a>
                    </div>
                    <div className="col-12"> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].instagram):"")!=""?
                   <>
                   <a href={(this.state.dati.lista2?this.state.dati.lista2[0].instagram:"")} 
                    target="_blank"  style={{cursor:'pointer'}}> 
                   <i className="pi pi-instagram mr-2" style={{ color:'#CFC6C3'}}></i> {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].instagram):"")}
                   </a>
                   </>:<></>}
                   </div>
                   <div className="col-12"> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].facebook):"")!=""?
                    <>
                   
                   <a href={(this.state.dati.lista2?this.state.dati.lista2[0].facebook:"")} 
                    target="_blank"  style={{cursor:'pointer'}}> 
                   <i className="pi pi-facebook mr-2" style={{ color:'#CFC6C3'}}></i> 
                   {(this.state.dati.lista2?this.splitfacebook(this.state.dati.lista2[0].facebook):"")}
                  </a>
                   </>:<></>}
                   </div>
                   
                   
               

              
             </div>     
             </div>
                 <div class="col-8">
                 <div className="col-12 col-12 md:col-12 lg:col-12 p-3">
               <div className="azie2">
                     <FormattedMessage id = "azienda.sudinoi" />
                   </div>
               </div>
               <div className="col-12 col-12 md:col-12 lg:col-12 p-3">
               <div className="azie3">
                {(this.state.dati.lista2?(
                 this.lingua()=='IT'? this.state.dati.lista2[0].info:this.state.dati.lista2[0].infoen
                     ):"")}
               </div>
               </div>
                      

                </div>
             </div>
             </div>:""}
              
             <div className="grid grid-nogutter">
        {(this.state.dati.conta4>0?this.state.dati.lista4.map((desc, index) => {
         return (
          <div className="p-2 col-12" >
          <div className="cardc mt-5 border-1 border-50 border-round">
            <div className="justify-content-center col-12">
                    <span className="text-500 font-medium">
                      {this.lingua()=='IT'?desc.nome:desc.nomeen}
                      </span>
            </div>
            <div className="col-12 text-center  ">
          
            <img style={{maxWidth:'200px',maxHeight:'200px',objectFit: 'contain'}} src={Costanti.UrlCallApi+'file/get/'+this.aziendaid+'/aziendaStoria/'+desc.id+'?'+Math.random()}  alt=""/>
            </div>
           
            <div className="col-12 justify-content-right text-900 font-medium">
            {this.lingua()=='IT'?desc.descrizione:desc.descrizioneen}
            </div>
           
          </div>
           </div>
           );
          }):"")}
        </div>


     

              

               {(this.state.dati.conta3>0?
        <div className="font-bold text-900 text-5xl mx-3 text-left border-round">  
        <DataTable value={this.state.dati.lista3} 
     rows={100} totalRecords={100}
     paginator={false} 
     responsive={true}  
     breakpoint="350px" autoLayout={true}
           responsiveLayout="stack">
           <Column id="id1" header={<FormattedMessage id = "azienda.stabilimento" />} headerClassName="cardc2"   
           body={(item) => (
            <div className="box">
             {item.codice}
            </div>
        )}
         />
                  <Column id="id1" header={<FormattedMessage id = "azienda.indirizzo" />} headerClassName="cardc2"   
           body={(item) => (
            <div className="box">
            

             <div onClick={()=>{this.mappa=item.indirizzo;this.setVisible1(true)}} style={{cursor:'pointer'}}>
              <i className="pi pi-map-marker mr-2"></i>
             {item.indirizzo}</div>
            </div>
        )}
         />
         
       
        
         
     </DataTable></div>:"")}

               
        {(this.state.dati.lista1?<div className="font-bold text-900 text-5xl mb-3 mx-3">
        <FormattedMessage id = "azienda.prodotti" />
        </div>:"")}
        <div className="grid grid-nogutter">
        {(this.state.dati.lista1?this.state.dati.lista1.map((desc, index) => {
         return (
          <div className="p-1 col-12 md:col-6 lg:col-4">
          <div className="cardc1  mx-4 mb-4 p-3 border-1 border-50 border-round md:h-full lg:h-full">
         
          <div className="flex align-items-center justify-content-center" 
          style={{ overflow: 'hidden', width: '100%', height: '400px'}}>
            <img src={Costanti.UrlCallApi+'file/get/'+desc.aziendaid+'/prodotto/'+desc.id+'?'+Math.random()} alt="" 
           style={{maxWidth:'100%', objectFit: 'cover' }}
                className="immagine"/>
            </div>
            <div className="col-12 azie4">
              {this.lingua()=='IT'?desc.nome:desc.nomeen}
            </div>
            <div className="col-12 justify-content-right">
            {this.split4(this.lingua()=='IT'?desc.descrizione:desc.descrizioneen)}
            </div>


            <div className="flex justify-content-end mx-3">
                     <span>
                          <Link to={"/"+(this.state.dati.lista2?this.state.dati.lista2[0].sigla:"")+"/schedapro/"+desc.id}>
                          <span className="pi pi-angle-right dash3"/>
                      </Link>
                    </span>
            </div>
         
         
          </div>
           </div>
           );
          }):"")}
        </div>
    
        </div>
        </div>
 
    )
    }
};

export default SchedaAzienda;
